import { useEffect, useState } from 'react';
import type { ForecastAdjustment } from '@/domain';
import { adjustmentService } from '@/services/adjustmentService';
import { mockStore } from '@/lib/mock-store';
import { isMockBackend } from '@/lib/supabase';

export function useAdjustments(): ForecastAdjustment[] {
  const [rows, setRows] = useState<ForecastAdjustment[]>([]);
  useEffect(() => {
    let alive = true;
    function refresh() {
      adjustmentService.list().then((data) => {
        if (alive) setRows(data);
      });
    }
    refresh();
    if (isMockBackend) return mockStore.subscribe(refresh);
    return () => {
      alive = false;
    };
  }, []);
  return rows;
}
